import React, { Component } from "react";
import { UISref } from "@uirouter/react";

import styled from "styled-components";
import styles from "./styles";

class Link extends Component {
  content() {
    return !!this.props.label ? this.props.label : this.props.children;
  }

  render() {
    const { className, onClick, url, style } = this.props;

    return (
      <div className={className} style={style}>
        {onClick && <a onClick={onClick}>{this.content()}</a>}
        {!onClick && (
          <UISref to={url}>
            <a>{this.content()}</a>
          </UISref>
        )}
      </div>
    );
  }
}
export default styled(Link)(...styles);



// WEBPACK FOOTER //
// ./src/components/support/link/index.jsx